import { compiledClientConfig } from "config";
import { useCompanyContext } from "context/companyContext";
import { type CompanyModel } from "models/CompanyModel";
import { useEffect } from "react";

import { useAuthenticatedUser } from "./useAuthenticatedUser";
import { useCaptureSiteName } from "./useCaptureSiteName";

export const useCompany = (): CompanyModel | null => {
  const { isLoggedIn } = useAuthenticatedUser();
  const {
    actions: { loadCompany },
    state: { company },
  } = useCompanyContext();

  useEffect(() => {
    if (!isLoggedIn && !compiledClientConfig.spog) return;

    void loadCompany();
  }, [isLoggedIn, loadCompany]);

  useCaptureSiteName();

  return company;
};
